/* global window */

// storage
// import * as storage from 'redux-storage'
// import createEngine from 'redux-storage-engine-localstorage'
// import filter from 'redux-storage-decorator-filter'
import Raven from 'raven-js'
// import createRavenMiddleware from "raven-for-redux";

import { getStore } from 'kea'
import sagaPlugin from 'kea-saga'
import localStoragePlugin from 'kea-localstorage'

// import { createStore, applyMiddleware, compose } from 'redux'
import { routerReducer, routerMiddleware } from 'react-router-redux'
// import createSagaMiddleware from 'redux-saga'
import { spawn, put } from 'redux-saga/effects'
import createHistory from 'history/createBrowserHistory'

// import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { formActionSaga } from 'redux-form-saga';

// import { createCombinedKeaReducer, createKeaStore, createRootSaga, logoutReducer } from './utils/kea'

import { reducer as configReducer, actions as configActions } from './config'
// import {storedReducers, localStorageKey} from './storage-config'

import { saga as entitiesSaga } from '~/entities'

// import rootLogic from '~/scenes/logic'
// import menuLogic from '~/components/menu/logic'
// import shopSelectorLogic from '~/components/shop-selector/logic'
// import searchLogic from '~/components/search/logic'
import rootSaga from '~/scenes/rootSaga'

const installRaven = process.env.NODE_ENV !== 'development';

if(installRaven) {
  Raven.config('https://8aab77ee1e51498e91e8830ce78f3f1f@sentry.io/1241533').install();
  if (typeof window !== 'undefined') {
    window.Raven = Raven;
  }
}

// const engine = filter(createEngine(localStorageKey), storedReducers);

// const storageMiddleware = storage.createMiddleware(engine, [], actionsWhitelist);

export function getInitialStateConfig () {
  const initialState = window.__INITIAL_STATE__ || {};

  let config = {...initialState};

  // TODO: remove the script tag from header

  if (Object.keys(config).length > 0) {
    return config
  }

  return {}
}

function * appSaga () {
  // yield [
  //   spawn(entitiesSaga),
  //   spawn(rootSaga),
  //   spawn(formActionSaga),
  // ];

  const config = getInitialStateConfig();
  if (Object.keys(config).length > 0) {
    yield put(configActions.receiveConfig(config))
  }

  yield spawn(entitiesSaga);
  yield spawn(rootSaga);
  yield spawn(formActionSaga);
}

const appReducers = {
  config: configReducer,
  routing: routerReducer,
  form: formReducer,
};

export const history = createHistory()

const rootSagaPlugin = {
  name: 'rootSaga',

  // must be used globally
  global: true,
  local: false,

  afterReduxStore: (options, store) => {
    if(options._sagaMiddleware) {
      console.log('running app sagas');
      options._sagaMiddleware.run(appSaga);
    }
  },
};

let middleWare = [
  routerMiddleware(history),
  // storageMiddleware
];

// const rootReducer = storage.reducer(logoutReducer(createCombinedKeaReducer({}, appReducers)));

// const sagaMiddleware = createSagaMiddleware();
// const finalCreateStore = compose(
//   applyMiddleware(routerMiddleware(browserHistory), sagaMiddleware),
//   applyMiddleware(storageMiddleware),
//   window.devToolsExtension ? window.devToolsExtension() : f => f
// )(createStore);

// export const load = storage.createLoader(engine);
// const store = createKeaStore(finalCreateStore, rootReducer, appReducers);

// export const initSagas = () => {
//   sagaMiddleware.run(createRootSaga(appSaga));
// };

export default getStore({
  plugins: [ localStoragePlugin, sagaPlugin, rootSagaPlugin ],
  paths: ['kea', 'scenes', 'entities', 'components', 'root'],
  middleware: middleWare,
  reducers: appReducers
})
